import React from 'react';
import { Button as PepsicoButton } from 'pepsico-ds';
import './StoreSelection.scss';

/**
 * StoreSelection component that displays multiple stores for user selection
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.storesList - Array of store objects with storeId and storeName
 * @param {Function} props.onStoreSelect - Function to handle store selection
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.dataTestId] - Test ID for the component
 * @returns {JSX.Element} The rendered StoreSelection component.
 */
const StoreSelection = ({
  storesList = [],
  onStoreSelect,
  className = '',
  dataTestId = 'store-selection-card'
}) => {
  return (
    <div className={`store-selection-wrapper ${className}`} data-testid={dataTestId}>
      <div className="store-selection-card">
        <div className="store-selection-header">
          <h6 className="store-selection-title">Multiple stores linked to your search:</h6>
        </div>
        <div className="store-selection-content">
          <div className="store-selection-buttons" data-testid="store-selection-buttons">
            {storesList.map((store) => (
              <PepsicoButton
                key={store.storeId}
                text={store.storeId}
                onClick={() => onStoreSelect(store)}
                variant="primary"
                size="medium"
                className="store-selection-button"
                data-testid={`store-button-${store.storeId}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreSelection;
